import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from './analytics';

// Renders nothing — initializes analytics once and emits a pageview on every
// route change. Must live inside <BrowserRouter> to use useLocation.
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    analytics.init();
  }, []);

  useEffect(() => {
    analytics.trackPageview();
  }, [location.pathname]);

  return null;
}
